/* eslint-disable max-params */
import { useEffect } from 'react';
import { getFeatures } from '../../utils/features';
export default function useRemoveSections(sections, podsData, setActiveSections, showZeroStateSections, zeroStateSections) {
    // Remove sections if necessary
    useEffect(() => {
        const features = getFeatures(Object.values(podsData || {})?.[0]?.request);
        if (showZeroStateSections) {
            if (!features.featureDisplayZeroStateRecommendations) {
                setActiveSections([]);
            }
            else {
                setActiveSections(zeroStateSections);
            }
        }
        else {
            setActiveSections(sections);
        }
    }, [zeroStateSections, showZeroStateSections, sections, podsData, setActiveSections]);
}
